<!-- 养护添加 -->
<template>
    <div>
        <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                    :tabslist="tabForm">
                    <template slot="tabs" slot-scope="scope">
                        <div class="table_content_box">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="100px" id="mainInfo" :show-message="false" :model="sendDataInfo"
                                    ref="sendDataInfo" size="mini" :disabled="dataActionBox.actionType == 2">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey" :label="formOneValue.showField"
                                            v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                            <!-- 检索方案 -->
                                            <el-input v-if="formOneValue.fieldType == 'search'" clearable
                                                v-model="sendDataInfo[formOneValue.entityField]"
                                                :disabled="dataActionBox.actionType==1"
                                                @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)">
                                                <el-button
                                                    @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    slot="append" icon="el-icon-search"></el-button>
                                            </el-input>
                                            <el-select clearable size="mini" filterable
                                                v-else-if="formOneValue.fieldType == 'formatter'"
                                                @change="((val) => { handleChange(val, formOneValue.entityField) })"
                                                v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                                    :key="matItem.key" :label="matItem.key"
                                                    :value="matItem.value"></el-option>
                                            </el-select>
                                            <el-input v-else v-model="sendDataInfo[formOneValue.entityField]"
                                                :disabled="false">
                                            </el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'"
                                            v-if="formOneValue.isShow == 1"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.fieldType == 'date'">{{
                                                $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}</span>
                                            <span v-else-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                    sendDataInfo[formOneValue.entityField] }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                                getValue(sendDataInfo[formOneValue.entityField],
                                                    formOneValue.entityField, formOneValue.fieldType,
                                                    formOneValue.formatterContent) }}</span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                    </template>
                </v-tabs>
            </el-card>
            <!-- 页脚 -->
            <div class="foots">
                <div style="text-align: center;">
                    <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                        @click="showPrintPlan">打印</el-button>
                    <el-button type="primary" @click="initActionBox('sendDataInfo')"
                        v-if="dataActionBox.actionType != 2">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
        </div>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
    name: "channelListAction",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            tabForm: [],
            mxForm: [],
            footForm: [],
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            mxHeight: 400,
            parentSearchData: {},
            sField: '',
            seType: ''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 下拉赋值
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.sField = sField
            this.DialogVisible = true;
            this.seType = type
            this.seId = sId;
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false; //关闭商品检索窗口
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        // 确认新增
        sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sub();
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.channelInfoAdd(sendData);
            } else {
                var responseData = await this.$http.channelInfoUpdate(sendData);
            }
            if (responseData.status == 200) {
                this.$emit("drawerCancel",1);
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消新增
        initActionBox(formName) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel");
                })
                .catch(() => { });
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
            } else if (this.dataActionBox.actionType == 1) {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in this.sendDataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.sendDataInfo.id=this.actionData.orderId
            } else if (this.dataActionBox.actionType == 2) {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in this.sendDataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach(item1 => {
                        if (item1.fieldType == 'number') {
                            this.$set(this.detaislDataInfo, item1.entityField, 0)
                        } else if (item1.fieldType == 'search' && item1.setField) {
                            var arr = item1.setField.split(',')
                            arr.forEach(item2 => {
                                this.$set(this.detaislDataInfo, item2, "")
                            })
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "")
                        }
                    })
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var obj = this.$common.filterMainFields(this.formDataList, [], mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-drawer {
    outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}

::v-deep .el-form-item__content {
    width: 200px;
}
</style>